import { Pipe, PipeTransform } from '@angular/core';
import { TemplateSearchOrder } from '@app-types/enums/TemplateSearchOrder';

@Pipe({
  name: 'formatTemplatesSearchOrders',
  standalone: true,
})
export class FormatTemplatesSearchOrders implements PipeTransform {
  transform(order: string): TemplateSearchOrder {
    switch (order) {
      case 'templateName':
        return TemplateSearchOrder.OrderByName;
      case 'templateDesc':
        return TemplateSearchOrder.OrderByDescription;
      case 'modifyDate':
        return TemplateSearchOrder.OrderByModifyDateTime;
      default:
        return TemplateSearchOrder.OrderByTemplateId;
    }
  }
}
